import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { User } from "lucide-react";

interface UserAvatarProps {
    src?: string | null;
    name?: string | null;
    className?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

const sizeMap = {
    sm: "h-8 w-8 text-[10px]",
    md: "h-10 w-10 text-xs",
    lg: "h-14 w-14 text-base",
    xl: "h-24 w-24 md:h-32 md:w-32 text-2xl",
};

export function UserAvatar({ src, name, className, size = "md" }: UserAvatarProps) {
    // Get initials from name (e.g., "Omar Ibrahim" -> "OI")
    const initials = name
        ? name.split(" ").map((n) => n[0]).join("").substring(0, 2).toUpperCase()
        : null;

    return (
        <div className={cn(
            "relative flex-shrink-0 rounded-full p-0.5 bg-white/50 dark:bg-white/10 border border-white/40 shadow-sm overflow-hidden",
            sizeMap[size],
            className
        )}>
            <Avatar className="w-full h-full rounded-full">
                <AvatarImage src={src || ""} alt={name || "User Avatar"} className="object-cover" />
                <AvatarFallback className="bg-gradient-to-br from-primary/10 to-indigo-500/10 text-primary font-bold">
                    {initials || <User className="h-1/2 w-1/2 opacity-50" />}
                </AvatarFallback>
            </Avatar>
        </div>
    );
}
